import { Bell } from '@lt/components/icons-react';
import React from 'react';
import fadeInAndOut from 'src/components/animations/SkeletonFadeInAndOut';
import styled, { css } from 'styled-components';

interface SubscribeLoaderProps {
  isMobile: boolean;
}

// TODO: привет гость из будующего, который интегрирует новую подписку тут я сразу для тебя подготовил все просто убери комменты и убери дубли и будет тебе подписка по дизайну
export const SubscribeLoader = ({
  isMobile,
}: SubscribeLoaderProps): JSX.Element => (
  <Container $isMobile={isMobile}>
    <BellIcon $isMobile={isMobile} />
    <TextBlock>
      <TextLoader $widthPercentage={90} />
      <TextLoader $widthPercentage={75} />
      <TextLoader $widthPercentage={90} />
    </TextBlock>
    {/*
    <LabelBlock>
      <Label $widthPixel={88} />
      <Label $widthPixel={89} />
      <Label $widthPixel={52} />
      <Label $widthPixel={97} />
    </LabelBlock>
    */}
    <ButtonLoader />
  </Container>
);

const mobileSubscribeLoader = css`
  min-width: 320px;
  width: auto;
  height: 100%;
  min-height: 500px;
`;

const desktopSubscribeLoader = css`
  width: 224px;
  height: 170px;
`;

const Container = styled.div<{ $isMobile: boolean }>`
  position: relative;
  border-radius: 6px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: 33px 10px 8px 10px;

  ${({ $isMobile }) =>
    $isMobile ? mobileSubscribeLoader : desktopSubscribeLoader}

  animation: ${fadeInAndOut} 1200ms ease-in-out infinite;
`;

const BellIcon = styled(Bell)<{ $isMobile: boolean }>`
  height: 32px;
  width: 32px;
  ${({ $isMobile }) =>
    $isMobile
      ? css`
          position: relative;
          margin: 0 auto;
        `
      : css`
          position: absolute;
          top: -16px;
          left: 8px;
        `}
`;

const TextBlock = styled.div`
  height: 46px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;

const TextLoader = styled.div<{ $widthPercentage: number }>`
  height: 1px;
  width: ${({ $widthPercentage }) => `${$widthPercentage}%`};
  margin-top: 10px;
  background: #e5e5e5;
`;

/*
const LabelBlock = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

const Label = styled.div<{ $widthPixel: number }>`
  border: 1px solid #e6e6e6;
  border-radius: 24px;
  height: 28px;
  width: ${({ $widthPixel }) => `${$widthPixel}px`};
`;
*/

const ButtonLoader = styled.div`
  width: 100%;
  background: #e6e6e6;
  border-radius: 2px;
  height: 40px;
`;
